
// THIS IS VERY DEPRICATED

export default class CollectionProto<T> {

    public MODEL_CLASS  : any
    public options  : any
    public _models  : T[] =   []
    public _byId  : { [key:string]  : T } = {}



    constructor(models?:object[], ModelClass:any = null, options={}) {

        this.MODEL_CLASS    = ModelClass;
        this.options        = options   // params passed to anynew model created

        // eh ??? models ? eto ze data prosto a ne objects eche ?
        // net problem - reset u nas umnii ochen :)
        this.reset(models);
    }

    // get all() {return this._models}
    get items() {return this._models}
    get models() {return this._models}

    get isEmpty() {
        return !this._models || this._models.length<1;
    }

    get length() {return this._models ? this._models.length : 0}

    get ids() {
        return _.keys(this._byId)
    }

    createModel(modelData:any, options:any) {
        return new this.MODEL_CLASS(modelData, options)
    }

    reset(models?:any[]) {
        this._models    = [];
        this._byId      = {};

        _.map(models, modelData=>{
            if (this.MODEL_CLASS)   this.add(this.createModel(modelData, this.options));
            else                    this.add(modelData);
        })
    }

    add(model:any) {
        this._models.push(model)
        this._byId[model.id] = model
    }

    remove(id:string) {
        delete this._byId[id];
        // @ts-ignore
        return _.remove(this._models, model=>model.id === id)
    }

    replace(id:string, model:any) {
        // find index of model to replace
        // @ts-ignore
        const index = _.findIndex(this._models, model=>model.id === id);

        // replace model at index
        this._models.splice(index, 1, model);

        delete this._byId[id]; // remove old model
        this._byId[model.id] = model; // add new model
    }

    get(id:string) {return this._byId[id];}

    // Delta
    applyDelta(method:string, data:any) {

        switch (method) {
            case 'delete':  this.remove(data.id); break;
            case 'new':     this.add(this.createModel(data, this.options)); break;

            case 'delta':
                const model = this.get(data.id);
                if (model) { // @ts-ignore
                    model.applyDelta(data);
                }
                break;
        }
    }

    // used when we want to store sort position within collection itself
    // i.e. manual sorting without sortPosition field
    reorderByIds(orderedIds:string[]) {
        const result:any[] = []
        _.map(orderedIds, id=>{
            result.push(this.get(id))
        })
        this._models = result;
    }
}
